import moment from "moment";

export default {
  formatDate(time) {
    if(!time) return "-";
    return moment(time).format("YYYY-MM-DD HH:mm:ss");
  },

  formatTime(time) {
    if(!time) return "-";
    return moment(time).format("YYYY-MM-DD");
  },

  formatPrice(price) {
    if(!price) return "0.00";
    if(typeof price === "string") {
      price = parseFloat(price);
    }
    return price.toFixed(2);
  }
}
